export interface PaymentFaq {
    question: string;
    answer: string;
}

export const PAYMENT_FAQS: PaymentFaq[] = [
    {
        question: 'How much does it cost?',
        answer: "Tandem charges a flat rate of 35% on top of the worker's hourly rate. For temp-to-permanent hires, there is a 120-hour cap.",
    },
    {
        question: 'When will I get charged?',
        answer: 'You will be charged on Sunday evening for wages and associated fees for the workers who worked the preceding week. You will have until 8pm on the day of the shift (or 3 hours after the shift ends, whichever is later) to correct or dispute any of the hours that were recorded by the worker for the day. Corrections should be made on the calendar on the Timesheets page.',
    },
    {
        question: 'Who sets the pay rate?',
        answer: 'You do! We know pay rates are not one size fits all. You will be able to set a pay scale when you post your need. Tandem will use your pay scale and notes to set the pay rate for each hired worker.',
    },
    {
        question: 'Who handles taxes?',
        answer: "Tandem's workers are 1099k contractors, so we issue all relevant tax forms to worker.",
    },
    {
        question: 'What type of payment methods can I use?',
        answer: 'You can add either a credit card or bank account. Credit cards incur a 2.9% + $.30 fee due to processing fees. Both payment methods can be connected via secure, third party payment processors, including Stripe.',
    },
    {
        question: 'How does my worker clock their hours?',
        answer: 'Workers clock in and out using the Tandem app. For ultimate accuracy, you can print a QR code located in the payments page of your account. Have Tandem workers scan this to clock in and scan it again to clock out. They will be prompted to add their break minutes as well.',
    },
    {
        question: "How do I adjust my worker's clocked hours?",
        answer: 'You can view clocked hours on the calendar under the My Jobs page of your account. Please adjust the hours on the calendar within 3 hours of the shift ending.',
    },
    {
        question: "Do I pay for worker's breaks?",
        answer: 'No, if a worker clocks a break, you will not be charged as this is unpaid time.',
    },
    {
        question: 'Will I receive a receipt?',
        answer: "Yes, after you've been charged on Sunday evening, you will receive a receipt via email.",
    },
    {
        question: 'How do I access my invoices?',
        answer: 'All paid and unpaid invoices can be downloaded from the payments page in your account. You can specify the time period, business location, and worker by which you want an invoice. Downloading an unpaid invoice allows you to see your outstanding charges for the current week.',
    },
];
